module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_61-374e07253d5be9d93fafda2a0fd52980.png";